// import RepositoryFactory from "@/apis";
// const corporate = RepositoryFactory.corporate;
import corporate from "../../apis/corporate";

export default {
  create({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // Update user details
        const { data } = await corporate.create(payload);
        // commit("ADD_BOOKING", payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  delete({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await corporate.delete(payload);

        // Update user details
        // commit("DELETE_Booking", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  edit({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await corporate.edit(payload);

        // Update user details
        commit("SELECT_Booking", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  get_all({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await corporate.get_all(payload);

        commit("GET_ALL", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
